import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { clubQueryKeys } from "./clubQueryKeys";

export function useQueryClubDetails({
  api,
  clubId,
}: {
  api: ApiType;
  clubId: number;
}) {
  return useQuery({
    queryKey: clubQueryKeys.details(clubId),
    queryFn: async () => {
      return (await api.clubApi.details(clubId)).data;
    },
    enabled: !!clubId,
  });
}
